import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ApexOptions} from "ng-apexcharts";
import { BATCH_COLORS } from '../../BATCH_COLORS';

@Component({
  selector: 'app-app-for-day-batch-chart',
  templateUrl: './app-for-day-batch-chart.component.html',
  styleUrls: ['./app-for-day-batch-chart.component.scss']
})
export class AppForDayBatchChartComponent implements OnChanges {
  @Input()  appForDay: any;
  @Input() batchData : any;

  chartAppBatchForDay: ApexOptions;

  constructor() { }

  ngOnChanges(changes:SimpleChanges): void {
    if(changes.batchData && changes.batchData.currentValue &&
        changes.appForDay && changes.appForDay.currentValue){
      this.chartAppBatchForDay = {
        series: [
          {
            name: this.batchData.labels[0],
            data: this.batchData.ai.series
          },
          {
            name: this.batchData.labels[1],
            data: this.batchData.aerospace.series
          },
          {
            name: this.batchData.labels[2],
            data: this.batchData.climate.series
          },
          {
            name: this.batchData.labels[3],
            data: this.batchData.adMan.series
          },
          {
            name: this.batchData.labels[4],
            data: this.batchData.biotech.series
          },
          {
            name: this.batchData.labels[5],
            data: this.batchData.quantum.series
          }
        ],
        chart: {
          type: "bar",
          animations: {
            speed: 400,
            animateGradually: {
              enabled: false
            }
          },
          fontFamily: 'inherit',
          foreColor: 'inherit',
          width: '100%',
          height: '100%',
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        xaxis: {
          type: "category",
          categories: this.appForDay.labels,
          labels : {
            format: 'dd MMM'
          }
        },
        legend: {
          position: "top",
          // offsetY: 40
        },
        fill: {
          opacity: 1
        },
        colors: BATCH_COLORS,
      };
    }
  }

}
